module.exports = __webpack_public_path__ + "img/Layer 7.1feadee7.svg";